module.exports = __webpack_public_path__ + "static/media/nag.6bbe0fa4.png";